import { configFetch as fetch } from '@meiqia/utils';

export const getCallTagListApi = () => {
  return fetch({
    url: '/unified-api/call/v1/tag',
    method: 'GET'
  });
};

export const addCallTagApi = data => {
  return fetch({
    url: '/unified-api/call/v1/tag',
    method: 'POST',
    data
  });
};

export const deleteCallTagApi = id => {
  return fetch({
    url: '/unified-api/call/v1/tag/' + id,
    method: 'DELETE'
  });
};

export const updateCallTagApi = (id, data) => {
  return fetch({
    url: '/unified-api/call/v1/tag/' + id,
    method: 'PUT',
    data
  });
};

export const unbindCallTagApi = data => {
  return fetch({
    url: '/unified-api/call/v1/record/unbind/tag',
    method: 'post',
    data
  });
};

export const bindCallTagApi = data => {
  return fetch({
    url: '/unified-api/call/v1/record/bind/tag',
    method: 'post',
    data
  });
};
